export type ThemeSource = { partner: string } | { mdm: string } | null;

/**
 * Picks where the public theme comes from: the URL partner, then the host of the Monarch that sent the device, then the stored partner.
 */
export const themeSource = (search: string, storedPartner: string | null): ThemeSource => {
  const params = new URLSearchParams(search);
  const urlPartner = params.get('partner');
  const mdm = params.get('mdm');

  if (urlPartner) return { partner: urlPartner };
  if (urlPartner === null && mdm) return { mdm };

  const partner = urlPartner ?? storedPartner;

  return partner ? { partner } : null;
};
